'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var winresServiceInfoController = function () {
    function winresServiceInfoController($scope) {
        _classCallCheck(this, winresServiceInfoController);

        this.$scope = $scope;
    }

    _createClass(winresServiceInfoController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.dates = [];
            this.$scope.$watch(function () {
                return _this.instances;
            }, this.updateDates());
        }
    }, {
        key: 'updateDates',
        value: function updateDates() {
            this.dates = _.map(this.instances, function (instance) {
                return {
                    begin: formatDate(instance.beginDate),
                    end: formatDate(instance.endDate)
                };
            });
        }
    }]);

    return winresServiceInfoController;
}();

function formatDate(iso) {
    return moment(iso).format('D.M.Y');
}

winresServiceInfoController.$inject = ['$scope'];

_module3.default.component('winresServiceInfo', {
    template: require('./winresServiceInfo.html'),
    controller: winresServiceInfoController,
    bindings: {
        name: '@',
        image: '@',
        description: '@',
        instances: '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServiceInfo/winresServiceInfo.js
// module id = 451
// module chunks = 2